import React from 'react'
import {Route, RouteProps} from 'react-router-dom'

const UnauthRoute = ( { component: Component, ...rest }:RouteProps ) => {
    return <Route component={Component} {...rest} />
}

export default UnauthRoute
